import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.css']
})
export class VideoComponent implements OnInit {

   icon_video_button_class: string = 'fa-play';
    text_video_button: string = 'Play Video';
  constructor() { }

  ngOnInit() {

  }

  playBackgroundVideo(event){
      var id_video = document.getElementById('video-source') as HTMLVideoElement;
      var parent = event.target.parentElement.parentElement;
    if(id_video.paused){
         id_video.play();
        this.text_video_button = 'Pause Video';
        this.icon_video_button_class = 'fa-pause';
     } else {
         id_video.pause();
        this.text_video_button = 'Play Video';
        this.icon_video_button_class = 'fa-play';
     }
  }
}
